import produce, { enableMapSet } from "immer";
import { Difficulty } from "shared/games/Difficulty";
import Instrument from "shared/games/instruments/Instrument";
import { MixPuzzle, MixPuzzleInstrument } from "shared/games/mixpuzzles/types";
import { GameAnswerMixPuzzle } from "shared/games/types/GameAnswers";
import Action from "./actions";
import getDefaultMixPuzzleInstruments from "./getDefaultMixPuzzleInstruments";
import initState from "./initState";

enableMapSet();

export interface State {
  difficulty: Difficulty;
  playbackState: "reference" | "mix";
  mixPuzzle: MixPuzzle;
  mix: { [instrument: string]: MixPuzzleInstrument };
  instrument: Instrument;
  multiMixMode: boolean;
  soloed: Instrument | null;
  muted: Set<Instrument>;
  grade: GameAnswerMixPuzzle["grade"] | undefined;
}

export default function reducer(state: State, action: Action): State {
  return produce(state, (draft) => {
    if (action.type === "requestPlaybackChange") {
      const { instrument, params } = action.payload;

      draft.mix[instrument] = {
        ...draft.mix[instrument],
        ...params,
      };
    } else if (action.type === "updateMultiMixMode") {
      if (action.payload === "toggle") {
        draft.multiMixMode = !draft.multiMixMode;
      } else {
        draft.multiMixMode = action.payload;
      }
    } else if (action.type === "updateSelectedInstrument") {
      draft.instrument = action.payload;

      // clear solo and mute when changing instruments
      draft.soloed = null;
      draft.muted = new Set();
    } else if (action.type === "updatePlaybackState") {
      draft.playbackState = action.payload;
    } else if (action.type === "togglePlaybackState") {
      draft.playbackState =
        draft.playbackState === "reference" ? "mix" : "reference";
    } else if (action.type === "updateMuted") {
      if (draft.muted.has(action.payload)) {
        draft.muted.delete(action.payload);
      } else {
        draft.muted.add(action.payload);

        if (draft.soloed === action.payload) {
          draft.soloed = null;
        }
      }
    } else if (action.type === "updateSoloed") {
      if (draft.soloed === action.payload) {
        draft.soloed = null;
      } else {
        draft.soloed = action.payload;
        draft.muted.delete(action.payload);
      }
    } else if (action.type === "startover") {
      draft.playbackState = "mix";
      draft.muted = new Set();
      draft.soloed = null;
      draft.multiMixMode = false;
      draft.mix = getDefaultMixPuzzleInstruments(draft.mixPuzzle);
    }
  });
}
